//トップページ　キービジュアルスライダー
import Swiper from 'swiper';

const indexTop = $('#indexTop').length;

export function idxFunc() {
  if (indexTop) {
    /*ピックアップ*/
    let pickupSwiper, pickupOptions;
    pickupSwiper = undefined;
    pickupOptions = {
      loop: true,
      speed: 800,
      effect: 'slide',
      normalizeSlideIndex: true,
      paginationClickable: true,
      breakpoints: {
        751: {
          slidesPerView: 3,
        },
        320: {
          centeredSlides: true,
          slidesPerView: 1.5,
          spaceBetween: '20px'
        }
      },
      navigation: {
        nextEl: '.pickupNext',
        prevEl: '.pickupPrev',
      },
      preloadImages: false,
      lazy: {
        elementClass: 'lazyload',
        loadPrevNextAmount: 2,
        loadPrevNext: true
      }
    };
    //スワイプ実行処理
    function initPickupSwiper() {
      pickupSwiper = new Swiper('#topSlide', pickupOptions);

    }
    initPickupSwiper();

    /*TOPICS*/
    let topicsSwiper, topicsOptions;
    topicsSwiper = undefined;
    topicsOptions = {
      loop: true,
      speed: 800,
      effect: 'slide',
      normalizeSlideIndex: true,
      paginationClickable: true,
      centeredSlides: true,
      breakpoints: {
        751: {
          slidesPerView: 3.8,
        },
        320: {
          centeredSlides: true,
          slidesPerView: 1.34,
        }
      },
      navigation: {
        nextEl: '.topicsNext',
        prevEl: '.topicsPrev',
      }
    };
    //スワイプ実行処理
    function initTopicsSwiper() {
      topicsSwiper = new Swiper('#topics', topicsOptions);
    }
    initTopicsSwiper();

    $(window).on('scroll', function () {
      const parallax = $('#parallax');
      const st = $(this).scrollTop();
      const pos = parallax.offset().top;
      parallax.css({
        "background-position-y": ((st - pos) / 15)
      });
    });
  }


  /*キャッチコピー取得*/
  //  let getTxt,txt2;
  //  
  //  getTxt = $('#h1Tag').html();
  //  
  //  
  //  txt2 = getTxt.replace( "<br>", "\A" ) ;
  //  
  // console.log(txt2);


}
